import React from 'react';

export const Header = (props) => {
  return (
    <header id='header'>
      <div className='container'>
        <p>
            For RO Repair in Delhi, Noida, Greater Noida, Ghaziabad, Gurugram & Faridabad and Home Visit Charge @299 Only. Best RO Repair Center in Delhi & NCT. Trained Technicians. Call Us - 18005712070
        </p>
      </div>
    </header>
  )
}
